<template>
  <v-container>
    <v-btn @click="dialog = true">
      button
    </v-btn>
    <!-- <s-pdf-js-annotation v-model="dialog" /> -->
  </v-container>
</template>

<script>
// import SPdfJsAnnotation from '@/components/SPdfJsAnnotation'

export default {
  // components: {
  //   SPdfJsAnnotation
  // },
  data: () => {
    return {
      dialog: false
    }
  }
}
</script>
